// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/videoChat/play_arrow_filled.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videoPlayer{
    position: relative;
    /*min-width: 400px;*/
    /*min-height: 300px;*/
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 120px - 122px); /*calc from header width and minimized subtitles*/
}

.videoPlayer_video{
    border-radius: 24px;
    width: 100%;
    height: 100%;
    background-color: #222;
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;
}

.videoPlayer_video_element{
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}

.videoPlayer_overlay{
    border-radius: 24px;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0002;
}

.videoPlayer_playButton{
    position: absolute;
    width: 57px;
    height: 57px;

    background-color: #FAFAFB;
    border-radius: 100%;
    background-position: center;
    background-size: 19px;
    background-repeat: no-repeat;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-size: 0;
}

.videoPlayer--isAudio .videoPlayer_video{
    background-color: transparent;
}

.videoPlayer_audio_element{
    width: 100%;
    object-fit: contain;
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/videoPlayer/VideoPlayer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,uCAAuC,EAAE,iDAAiD;AAC9F;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;;IAEhB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;;IAEP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;;IAEZ,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;IACrB,4BAA4B;;IAE5B,yDAAqE;IACrE,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".videoPlayer{\n    position: relative;\n    /*min-width: 400px;*/\n    /*min-height: 300px;*/\n    width: 100%;\n    height: 100%;\n    max-height: calc(100vh - 120px - 122px); /*calc from header width and minimized subtitles*/\n}\n\n.videoPlayer_video{\n    border-radius: 24px;\n    width: 100%;\n    height: 100%;\n    background-color: #222;\n    overflow: hidden;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.videoPlayer_video_element{\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    display: block;\n}\n\n.videoPlayer_overlay{\n    border-radius: 24px;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #0002;\n}\n\n.videoPlayer_playButton{\n    position: absolute;\n    width: 57px;\n    height: 57px;\n\n    background-color: #FAFAFB;\n    border-radius: 100%;\n    background-position: center;\n    background-size: 19px;\n    background-repeat: no-repeat;\n\n    background-image: url(\"../../assets/videoChat/play_arrow_filled.svg\");\n    font-size: 0;\n}\n\n.videoPlayer--isAudio .videoPlayer_video{\n    background-color: transparent;\n}\n\n.videoPlayer_audio_element{\n    width: 100%;\n    object-fit: contain;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
